export const effectIds: Readonly<string[]> = [
    '6617953c7c17cae7ab78ce11',
    '6645fd42616cc63ad1b8e233',
    '5d88c7f0fb866a000137aa8c',
    '66685471234e968648cc43be',
    '66c6e5fb731bbf7f307e652f'
];
